import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Cookie } from 'lucide-react';
import { useCookieConsent } from '../lib/cookieConsent';

export default function CookieConsentBanner() {
  const location = useLocation();
  const { hasAnswered, setChoice } = useCookieConsent();

  if (hasAnswered || location.pathname.startsWith('/admin-gameside-caen')) {
    return null;
  }

  return (
    <div className="fixed inset-x-0 bottom-0 z-[120] px-4 pb-4 sm:px-6 sm:pb-6 pointer-events-none">
      <div className="mx-auto max-w-5xl rounded-2xl border border-white/10 bg-[#14151f] text-white shadow-[0_22px_70px_rgba(0,0,0,0.34)] pointer-events-auto">
        <div className="grid grid-cols-1 gap-5 p-5 sm:p-6 lg:grid-cols-[auto_1fr_auto] lg:items-center">
          <div className="flex h-12 w-12 items-center justify-center rounded-full bg-yellow-400 text-[#14151f]">
            <Cookie size={24} strokeWidth={2.4} />
          </div>

          <div>
            <p className="mb-2 text-sm font-black uppercase tracking-[0.22em] text-yellow-400">
              Gestion des cookies
            </p>
            <p className="text-sm font-medium leading-relaxed text-white/78">
              Nous utilisons un cookie nécessaire pour mémoriser votre choix. Google Analytics, Google Ads, Google Maps et YouTube sont chargés uniquement si vous acceptez les cookies optionnels.
              <Link to="/politique-de-cookies-ue" className="ml-1 font-bold text-white underline decoration-yellow-400 decoration-2 underline-offset-4">
                Voir la politique
              </Link>
            </p>
          </div>

          <div className="flex flex-col gap-3 sm:flex-row lg:flex-col xl:flex-row">
            <button
              type="button"
              onClick={() => setChoice('refused')}
              className="rounded-full border-2 border-white/20 px-5 py-3 text-sm font-black uppercase tracking-wide text-white transition-colors hover:border-white"
            >
              Refuser
            </button>
            <button
              type="button"
              onClick={() => setChoice('accepted')}
              className="rounded-full bg-gradient-to-r from-yellow-400 to-orange-500 px-5 py-3 text-sm font-black uppercase tracking-wide text-[#14151f] transition-colors hover:from-yellow-300 hover:to-orange-400"
            >
              Accepter
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
